import { useTranslation } from "@i18n";
import { useEffect, useState, useRef } from "react";
import { getFlatTreeViewOfDistinctFileProperties } from "@Services/utils/helpers";
import TreeSelectDropDown from "@CubeComponents/html/TreeDropDown";
/** The distinct-property rows `getFlatTreeViewOfDistinctFileProperties` accepts (its own param type). */
type FileColumnInput = Parameters<typeof getFlatTreeViewOfDistinctFileProperties>[0];

type props = {
  columns: FileColumnInput;
  /**
   * The selected column row. METHOD shorthand so the parameter stays bivariant: all five call sites
   * converge on `{ field: string }` (TakeoffWizard's `FileColumnChange`, SearchSet1's inline
   * annotation, QuerySettings' `args?.field`), and each is assignable TO the all-optional shape
   * below, which is the direction bivariance uses.
   *
   * Previously `Function`. A bare `Function` is assignable FROM anything and TO nothing, so it
   * matches no call signature in either direction — it defeats every variance technique by
   * construction and silently widens whatever it is forwarded into.
   */
  change(params: { field?: string; id?: string; label?: string }): void;
  value?: string | null;
  placeholder?: string;
};

function FileColumnsTreeView({ columns, change, value, placeholder }: props) {
  const { t } = useTranslation();
  const [columnData, setColumnData] = useState<ReturnType<typeof getFlatTreeViewOfDistinctFileProperties>>([]);
  const treeRef = useRef<React.ComponentRef<typeof TreeSelectDropDown>>(null);

  useEffect(() => {
    // Use flat data with parentId references
    setColumnData(
      getFlatTreeViewOfDistinctFileProperties(
        columns,
        undefined,
        undefined,
        { selectable: true },
        { selectable: false },
      ),
    );
  }, [columns]);

  return (
    <div className="w-full">
      <TreeSelectDropDown
        value={value}
        ref={treeRef}
        treeData={columnData}
        placeholder={placeholder || t("Select Quantity Parameter")}
        enableCheckboxSelection={false}
        multiple={false}
        onSelectionChange={change}
        popoverWidth={300}
        selectCheckBoxOnRowClick
        popoverHeight={400}
        disabledParentSelection
      />
    </div>
  );
}

export default FileColumnsTreeView;
